// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__swGhS","question":"styles_question__3f2Tb","description":"styles_description__3RklX"};